import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-history-stats-dialog-item',
  templateUrl: './user-history-stats-dialog-item.component.html',
  styleUrls: ['./user-history-stats-dialog-item.component.scss']
})
export class UserHistoryStatsDialogItemComponent {
  @Input() icon?: string;
  @Input() label!: string;
  @Input() value!: string;
}
